export default ['2px', '4px', '8px', '16px'];
